import React from "react";
import { useForm, FormProvider as FormContext } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers";
import { object, number, string, date, array } from "yup";

const validationSchema = object().shape({
  type: string()
    .oneOf([
      "Private Office",
      "Hot Desk",
      "Dedicated Desk",
      "2gethr Connect",
      "2gethr DayPass",
    ])
    .required("Membership Type is required."),
  name: string().required("Company Name is required."),
  startDate: date()
    .typeError("Start Date must be a valid date")
    .required("Membership Start Date is required."),
  endDate: date()
    .typeError("End Date must be a valid date")
    .required("Membership End Date is required."),
  lockingPeriod: number()
    .typeError("Locking Period must be a number")
    .optional()
    .when("type", {
      is: (type) => type !== "2gethr Connect",
      then: number().typeError("Locking Period must be a number").required(),
    }),
  annualEscalation: number()
    .typeError("Annual Escalation must be a number")
    .when("type", {
      is: (type) => type !== "2gethr Connect",
      then: number().typeError("Annual Escalation must be a number").required(),
    }),
  securityDeposit: number()
    .typeError("Security Deposit must be a number")
    .when("type", {
      is: (type) => type !== "2gethr Connect",
      then: number().typeError("Security Deposit must be a number").required(),
    }),
  workStationSeats: number()
    .typeError("Work Station Seats must be a number")
    .when("type", {
      is: (type) => type !== "2gethr Connect",
      then: number()
        .typeError("Work Station Seats must be a number")
        .required(),
    }),
  additionalServices: array().of(
    object().shape({
      // id: string().required(),
      rate: number().required(),
      name: string().required(),
      endDate: date().required(),
      startDate: date().required(),
      quantity: number().required(),
    })
  ),
  totalDayPasses: number()
    .typeError("Total Day Passes must be a number")
    .when("type", {
      is: "2gethr Connect",
      then: number().typeError("Total Day Passes must be a number").required(),
    }),
  collabAreaSeats: number().typeError("Collab area seats must be a number"),
  meetingRoomSeats: number().typeError("Meeting room seats must be a number"),
  onboardingCharges: number().typeError("Onboarding charges must be a number"),
  exitCharges: number().typeError("Exit charges must be a number"),

  // noOfWorkStations: number().when("membershipType", {
  //   is: membershipType => membershipType === "Private Office",
  //   then: number().required("Number of Workstations are required"),
  //   otherwise: number()
  // }),

  // rate: number()
  //   .typeError("Rate must be a number")
  //   .required("Price /work unit/ month is required."),
});

const UpdateMembershipContext = ({ children }) => {
  const methods = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      workStationSeats: 0,
      collabAreaSeats: 0,
      meetingRoomSeats: 0,
      onboardingCharges: 0,
      exitCharges: 0,
      lockingPeriod: 0,
      securityDeposit: 0,
      annualEscalation: 0,
      rate: 0,
      totalDayPasses: 0,
      buildingId: { name: "" },
      type: { name: "" },
    },
  });

  return <FormContext {...methods}>{children}</FormContext>;
};

export default UpdateMembershipContext;
